import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { BaseComponent } from '../../../shared/class/base-component.class';
import { RequestStatus } from '../../../shared/enums/request-status.enum';
import { ApiResponse } from '../../../shared/interfaces/api-response.interface';
import { FileUploadReq } from '../../models/file-upload-req';
import { MessageType } from '../../../shared/enums/message-type.enum';
@Component({
  selector: 'app-matching-container',
  templateUrl: './matching-container.component.html',
  styleUrl: './matching-container.component.scss'
})
export class MatchingContainerComponent extends BaseComponent implements OnInit {
  reconciliation: any[] = []
  fileData: any = [] = [];
  visible: boolean = false;
  errorTitle:string = '';
  // videoVisible: boolean = false;
  videoSource = "https://storage.googleapis.com/recon_video/recon_final.mp4";
  thumbnailSource: string = '../../../../assets/images/video_thumbnail.jpeg';

  @ViewChild('videoPlayer') videoPlayer!: ElementRef;
  @ViewChild('responseContainer') responseContainer!: ElementRef;

  constructor(private http: HttpClient, private confirmationService: ConfirmationService) {
    super();
  }
  ngOnInit(): void {
    if(!this.hasActiveSubscription()){
      //this.router.navigateByUrl('/subscription');
    }
  }

  copyToClipboard(text: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    this.notificationService.notify(`Copied to clipboard: ${text} `, MessageType.Info);
  }

  async fileUpload(data: FileUploadReq) {
    const {files} = data;
    if(!files.length){
      this.notificationService.showError('Select any file to continue');
      return;
    }
    if(files.length > 1){
      this.notificationService.showError("You can't upload more than 1 file");
      return;
    }

    let body: FormData = new FormData();
    files.forEach((file: File) => {
      body.append('files', file, file.name);
    });
    body.append('data', JSON.stringify(data.data));
    this.requestStatus = RequestStatus.Inprogress;
    let response: ApiResponse<any> =
      await this.httpService.httpRequest<any>(
        "matching",
        "gst-2b",
        body,
        {
          showLoader: false
        }
      );
    if (response.status && response.data) {
      this.fileData = response.data;
      this.requestStatus = RequestStatus.Completed;
      this.scrollToElement();
      this.notificationService.showSuccess('File Processed Successfully')
    } else {

      if ((response as any)?.validationError) {
        this.requestStatus = RequestStatus.None;
        this.errorTitle = response.error.title;
        this.confirmationService.confirm({
          header: response.error.title,
          message: response.error.message,
          acceptButtonStyleClass: 'p-button-danger p-button',
        });
        return;
      }
      this.notificationService.showError(response.message)
      this.requestStatus = RequestStatus.None;

    }
  }

  scrollToElement(): void {
    this.responseContainer?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  onReset() {
    this.requestStatus = RequestStatus.None;
    // this.router.navigateByUrl('/gst-recon')
    // location.reload()
  }

  showHelp(){
    if(this.visible == false){
      this.visible = true
    } else {
      this.visible = false
    }
  }

  // showVideo() {
  //   this.videoVisible = !this.videoVisible;
  // }

  helpTableData = [
    { field: 'GSTN', books: true, gstr2b: true },
    { field: 'INVOICE_NUMBER', books: true, gstr2b: true },
    { field: 'TAXABLE_VALUE', books: true, gstr2b: true },
    { field: 'IGST', books: true, gstr2b: true },
    { field: 'CGST', books: true, gstr2b: true },
    { field: 'SGST', books: true, gstr2b: true },
    { field: 'ITC_AVAILABILITY', books: false, gstr2b: true },
    { field: 'INVOICE_DATE', books: true, gstr2b: false }
  ];
}
